<div id="anc-junior-pilot" class="l-section u-mt-sp-32 u-mt-tb-40 u-mt-pc-56">
  <div class="p-heading-area01">
    <div class="p-heading-area01__title">
      <!-- [10.1] ヘルプアイコン ※ジュニアパイロット見出し -->
      <h2 class="c-heading-2" role="heading" aria-level="2">
        <span class="c-text-with-tooltip">
          <span class="c-text-with-tooltip__text" [innerHTML]="'label.juinorPilot' | staticMsg"></span>
          <span class="c-text-with-tooltip__tooltip js-tooltip">
            <!-- 提携: <asw-tooltip>にリファクタ予定 -->
            <button
              id="junior-pilot-help"
              class="c-text-with-tooltip__btn js-tooltip-btn"
              [aswTooltip]="'tooltip.juniorPilot' | staticMsg"
              [tooltipTop]="0"
              aria-expanded="false"
            >
              <!-- TODO + Q&A UIUXS2-10261 -->
              <span class="u-visually-hidden">Hint</span>
            </button>
          </span>
        </span>
      </h2>
      <!-- /[10.1] ヘルプアイコン ※ジュニアパイロット見出し -->
    </div>
    <div class="p-heading-area01__sub-function">
      <!-- [10.3] ジュニアパイロット申込 -->
      <div class="p-heading-area01__sub-function-item" *ngIf="isDisplayJuniorPilotApp()">
        <button
          class="c-btn-primary c-btn-primary--external c-btn-primary--xs"
          id="junior-pilot-edit-btn"
          (click)="clickJuniorPilotApp()"
        >
          <span class="c-btn-primary__text" [innerHTML]="'label.editButton' | staticMsg"></span>
          <!-- TODO + Q&A UIUXS2-10261 -->
          <span class="u-visually-hidden">
            This page will open in a new tab. If the page is on an external website, it may not be in line with
            accessibility guidelines.
          </span>
        </button>
      </div>
      <!-- /[10.3] ジュニアパイロット申込 -->
    </div>
  </div>

  <div [ngClass]="['p-plan-table js-plan-table01-item', isScrollJuniorPilot ? 'is-scroll' : '']">
    <div class="p-plan-table__contents">
      <div class="p-plan-table__scroll">
        <asw-table-slider id="junior-pilot-slider" (isScrollChange)="scrollJuniorPilot($event)">
          <div class="p-plan-table__scroll-view">
            <div class="p-plan-table__scroll-inner js-plan-table01-scroll" #detailPanel>
              <table class="c-plan-table01 c-plan-table01--6col js-plan-table01" #scrollPanel>
                <caption class="u-visually-hidden" [innerHTML]="'label.juniorPilot' | staticMsg"></caption>
                <thead class="c-plan-table01__head">
                  <tr class="c-plan-table01__inner">
                    <td class="c-plan-table01__col">
                      <div class="c-plan-table01__col-inner"></div>
                    </td>
                    <ng-container *ngFor="let flight of juniorPilotFlightInforList">
                      <th class="c-plan-table01__col" scope="col">
                        <div class="c-plan-table01__col-inner">
                          <div class="c-plan-table01__col-item c-plan-table01__col--em">
                            <span class="c-flight-info01__title-airport">
                              <!-- [10.5] 出発地 -->
                              <span class="c-flight-info01__title-airport-departure">
                                {{ getlocationNameDeparture(flight?.departure) }}
                                <span class="c-flight-info01__title-airport-to">
                                  <span
                                    class="u-visually-hidden"
                                    [innerHTML]="'alt.toOfArrivalAndDeparture' | staticMsg"
                                  ></span>
                                  <span aria-hidden="true" [innerHTML]="'label.hyphen' | staticMsg"></span>
                                </span>
                              </span>
                              <!-- /[10.5] 出発地 -->
                              <!-- [10.6] 到着地 -->
                              <span class="c-flight-info01__title-airport-arrival">
                                {{ getlocationNameArrival(flight.arrival) }}
                              </span>
                              <!-- /[10.6] 到着地 -->
                            </span>
                          </div>
                        </div>
                      </th>
                    </ng-container>
                  </tr>
                </thead>
                <tbody class="c-plan-table01__body">
                  <ng-container *ngFor="let traveler of juniorPilotPassengerInforList">
                    <tr class="c-plan-table01__inner">
                      <th class="c-plan-table01__col" scope="row">
                        <div class="c-plan-table01__col-inner">
                          <!-- [10.8] 搭乗者姓名 -->
                          <div class="c-plan-table01__col-item c-plan-table01__col-item--em">
                            {{ getTravelerName(traveler) }}
                          </div>
                          <!-- /[10.8] 搭乗者姓名 -->
                        </div>
                      </th>
                      <ng-container *ngFor="let flight of juniorPilotFlightInforList">
                        <td class="c-plan-table01__col">
                          <asw-junior-pilot-item
                            [flight]="flight"
                            [traveler]="traveler"
                            [pnr]="pnr"
                          ></asw-junior-pilot-item>
                        </td>
                      </ng-container>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
          </div>
        </asw-table-slider>
      </div>
    </div>
  </div>
</div>
